import { PostData } from '../types';
import { MediaType } from '../../../../../models/graphql';

export const videoStoryOver60Sec = (data: PostData) =>
  data.feedType === 'story' &&
  data.media?.type === MediaType.VIDEO &&
  data.media.videoLength &&
  data.media.videoLength > 60;
